import { createAsyncAction } from "../actionCreators";
import { API, AccountCharge } from "@thenounproject/lingo-core";

type Args = {
  chargeId: number;
  spaceId: number;
  receiptExtra?: string;
};

const [useEditInvoice, editInvoice] = createAsyncAction(
  "billing/editInvoice",
  async ({ chargeId, receiptExtra }: Args) => {
    const res = await API.call<{ charge: AccountCharge }>({
      endpoint: `invoices/${chargeId}/`,
      method: "PUT",
      data: {
        charge_id: chargeId,
        receipt_extra: receiptExtra,
      },
    });
    return { ...res, result: res.result.charge };
  }
);

export default useEditInvoice;
export { editInvoice };
